import getDomain from '@/utils/domain';
import getLayoutType from '@/utils/layoutType';

// Content route for main layout
export const CONTENT_ROUTES = {
    a_shipping_request: {
        module: 'admin/shipping-request/list/index',
        nameModule: 'shippingRequestList',
        title: 'パッケイ ロジスティクス - 注文受付',
        css: 'admin/shipping-request/list/index.css'
    },
    a_warehouse_companies: {
        module: 'admin/warehouse-companies/list/index',
        nameModule: 'warehouseCompaniesList',
        title: 'パッケイ ロジスティクス - 倉庫会社一覧',
        css: 'admin/warehouse-companies/list/index.css'
    },
    a_warehouse_companies_registration: {
        module: 'admin/warehouse-companies/registration/index',
        nameModule: 'warehouseCompanyRegistration',
        title: 'パッケイ ロジスティクス - 倉庫会社登録'
    },
    a_warehouse_companies_edit: {
        module: 'admin/warehouse-companies/edit/index',
        nameModule: 'warehouseCompanyEdit',
        title: 'パッケイ ロジスティクス - 倉庫会社編集',
        params: ['companyId']
    },
    a_warehouse_list: {
        module: 'admin/warehouse/list/index',
        nameModule: 'warehouseList',
        title: 'パッケイ ロジスティクス - 倉庫一覧',
        params: ['companyId'],
        css: 'admin/warehouse/list/index.css'
    },
    a_shipping_request_detail: {
        module: 'admin/shipping-request/detail/index',
        nameModule: 'shippingRequestDetail',
        title: 'パッケイ ロジスティクス - 注文内容',
        params: ['request_id'],
        css: 'admin/shipping-request/detail/index.css'
    },
    a_warehouse_edit: {
        module: 'admin/warehouse/edit/index',
        nameModule: 'warehouseEdit',
        title: 'パッケイ ロジスティクス - 倉庫編集',
        params: ['id', 'companyId'],
        css: 'admin/warehouse/edit/index.css'
    },
    a_item_frame: {
        module: 'admin/item-management/index',
        nameModule: 'itemManagement',
        title: '在庫商品一覧　ー在庫商品の検索ー',
        css: 'admin/item-management/index.css'
    },
    a_user_frame: {
        module: 'admin/customer-management/index',
        nameModule: 'customerManagement',
        title: 'パッケイ ロジスティクス - 顧客管理',
        css: 'admin/customer-management/index.css'
    },
    a_warehouse_registration: {
        module: 'admin/warehouse/registration/index',
        nameModule: 'warehouseRegistration',
        title: 'パッケイ ロジスティクス - 倉庫登録',
        css: 'admin/warehouse/registration/index.css',
        params: ['companyId']
    },
    a_user_frame_registration: {
        module: 'admin/customer-management/registration/index',
        nameModule: 'customerManagementRegistration',
        title: 'パッケイ ロジスティクス - 顧客登録'
    },
    a_staff_frame: {
        module: 'admin/saff-management/index',
        nameModule: 'saffManagement',
        title: 'パッケイ ロジスティクス - 担当者一覧'
    },
    a_staff_insert: {
        module: 'admin/saff-management/staff-insert/index',
        nameModule: 'staffInsert',
        title: 'パッケイ ロジスティクス - 担当者登録'
    },
    a_staff_edit: {
        module: 'admin/saff-management/staff-edit/index',
        nameModule: 'staffEdit',
        title: 'パッケイ ロジスティクス - 担当者編集',
        params: ['staffId']
    },
    a_item_insert: {
        module: 'admin/item-management/insert/index',
        nameModule: 'itemInsert',
        title: 'パッケイ ロジスティクス - 商品入庫',
        css: 'admin/item-management/insert/index.css',
        params: ['copyFromItemId']
    },
    a_item_edit: {
        module: 'admin/item-management/edit/index',
        nameModule: 'itemEdit',
        title: 'パッケイ ロジスティクス - 在庫商品編集',
        params: ['itemId'],
        css: 'admin/item-management/edit/index.css'
    },
    a_registitem_frame: {
        module: 'admin/registitem-frame/index',
        nameModule: 'registitemFrame',
        title: 'パッケイ ロジスティクス - 商品マスター一覧'
    },
    a_csv_upload: {
        module: 'admin/csv-upload/index',
        nameModule: 'csvUpload',
        title: 'パッケイ ロジスティクス - 商品マスターの受け入れ',
        css: 'admin/csv-upload/index.css',
        domain: 'admin'
    },
    u_delivery_destination_list: {
        module: 'user/delivery-destination-list/index',
        nameModule: 'deliveryDestinationList',
        title: 'パッケイ ロジスティクス - 配送先一覧',
        css: 'user/delivery-destination-list/index.css',
        domain: 'user'
    },
    u_delivery_destination_registration: {
        module: 'user/delivery-destination-management/insert/index',
        nameModule: 'deliveryDestinationInsert',
        title: 'パッケイ ロジスティクス - 配送先登録',
        css: 'user/delivery-destination-management/index.css',
        domain: 'user'
    },
    u_delivery_destination_edit: {
        module: 'user/delivery-destination-management/edit/index',
        nameModule: 'deliveryDestinationEdit',
        title: 'パッケイ ロジスティクス - 配送先編集',
        css: 'user/delivery-destination-management/index.css',
        domain: 'user',
        params: ['deliveryId']
    },
    u_item_frame: {
        module: 'user/order-page/index',
        nameModule: 'orderPage',
        title: 'パッケイ ロジスティクス - 注文（在庫商品一覧）',
        css: 'user/order-page/index.css',
        domain: 'user'
    },
    u_request_frame: {
        module: 'user/request-history/index',
        nameModule: 'userRequestHistory',
        title: 'パッケイ ロジスティクス - 注文履歴',
        css: 'user/request-history/index.css',
        domain: 'user'
    },
    u_request_confirm: {
        module: 'user/request-confirm/index',
        nameModule: 'requestConfirm',
        title: 'パッケイ ロジスティクス - 発送依頼内容の確認',
        css: 'user/request-confirm/index.css',
        domain: 'user',
        params: ['requestId']
    },
    u_person_in_charge_list: {
        module: 'user/person-in-charge-list/index',
        nameModule: 'personInChargeList',
        title: 'パッケイ ロジスティクス - 担当者一覧',
        css: 'user/person-in-charge-list/index.css',
        domain: 'user'
    },
    u_person_in_charge_registration: {
        module: 'user/person-in-charge-management/insert/index',
        nameModule: 'personInChargeRegistration',
        title: 'パッケイ ロジスティクス - 担当者新規登録',
        css: 'user/person-in-charge-management/insert/index.css',
        domain: 'user'
    },
    u_person_in_charge_edit: {
        module: 'user/person-in-charge-management/edit/index',
        nameModule: 'personInChargeEdit',
        title: 'パッケイ ロジスティクス - 担当者情報',
        css: 'user/person-in-charge-management/edit/index.css',
        domain: 'user',
        params: ['staff_id']
    },
    u_request_item: {
        module: 'user/ordering-process/u-request-item/index',
        nameModule: 'uRequestItem',
        title: 'パッケイ ロジスティクス - 発送依頼',
        css: 'user/ordering-process/u-request-item/index.css',
        domain: 'user'
    },
    u_product_detail: {
        module: 'user/product/product-detail/index',
        nameModule: 'productDetail',
        title: 'パッケイ ロジスティクス - 在庫商品詳細',
        css: 'user/product/product-detail/index.css',
        domain: 'user',
        params: ['productId']
    },
    u_cart: {
        module: 'user/cart-page/index',
        nameModule: 'cartPage',
        title: 'パッケイ ロジスティクス - カート',
        css: 'user/cart-page/index.css',
        domain: 'user'
    },
    u_request_item_confirm: {
        module: 'user/ordering-process/u-request-item-confirm/index',
        nameModule: 'uRequestItemConfirm',
        title: 'パッケイ ロジスティクス - 発送依頼 (確認)',
        css: 'user/ordering-process/u-request-item-confirm/index.css',
        domain: 'user'
    },
    u_inquiry: {
        module: 'user/u-inquiry/index',
        nameModule: 'uInquiry',
        title: 'パッケイ ロジスティクス - お問い合わせ',
        css: 'user/u-inquiry/index.css',
        domain: 'user'
    },
    u_chart_product: {
        module: 'user/product/chart-product/index',
        nameModule: 'chartProduct',
        title: 'パッケイ ロジスティクス - 商品売上チャート',
        css: 'user/product/chart-product/index.css',
        domain: 'user'
    },
    // Staff content routes (reuse admin pages for now)
    s_item_frame: {
        module: 'staff/item-management/index',
        nameModule: 'itemManagement',
        title: 'パッケイ ロジスティクス - 在庫商品一覧',
        css: 'staff/item-management/index.css',
        domain: 'staff'
    },
    s_request_frame: {
        module: 'staff/shippingRequest/index',
        nameModule: 'shippingRequestList',
        title: 'パッケイ ロジスティクス - 注文受付',
        css: 'staff/shippingRequest/index.css',
        domain: 'staff'
    },
    s_inquiry: {
        module: 'staff/inquiry/index',
        nameModule: 'inquiry',
        title: 'パッケイ ロジスティクス - お問い合わせ',
        css: 'staff/inquiry/index.css',
        domain: 'staff'
    },
    s_request_detail: {
        module: 'staff/s_request_detail/index',
        nameModule: 'sRequestDetail',
        title: 'パッケイ ロジスティクス - 注文内容',
        css: 'staff/s_request_detail/index.css',
        domain: 'staff',
        params: ['request_id']
    },
    s_warehouse_contact: {
        module: 'staff/warehouse_contact/index',
        nameModule: 'warehouseContact',
        title: 'パッケイ ロジスティクス - 担当者情報',
        css: 'staff/warehouse_contact/index.css',
        domain: 'staff'
    },
    s_item_detail: {
        module: 'staff/item-management/detail/index',
        nameModule: 'itemDetail',
        title: 'パッケイ ロジスティクス - 在庫商品情報',
        css: 'staff/item-management/detail/index.css',
        domain: 'staff',
        params: ['stockProductId']
    },
    u_regist_infor: {
        module: 'user/warehouse-company-info/index',
        nameModule: 'warehouseCompanyInfoPage',
        title: 'パッケイ ロジスティクス - 企業基本情報',
        css: 'user/warehouse-company-info/index.css',
        domain: 'user',
        params: ['companyId']
    },
    u_regist_edit: {
        module: 'user/warehouse-company-info-edit/index',
        nameModule: 'warehouseCompanyInfoEdit',
        title: 'パッケイ ロジスティクス - 顧客企業編集',
        css: 'user/warehouse-company-info-edit/index.css',
        domain: 'user'
    }
};

// Auth routes for main layout
export const AUTH_ROUTES = {
    // Shared login step one route (works for all domains)
    login_step_one: {
        // Module path will be resolved dynamically based on domain
        nameModule: 'authLoginEmail',
        title: 'パッケイ ロジスティクス - ログイン',
        // CSS will be resolved dynamically based on domain
        domain: 'shared' // Special domain marker for shared routes
    },

    a_login_step_two: {
        module: 'admin/auth/login/password/index',
        nameModule: 'authLoginPassword',
        title: 'パッケイ ロジスティクス - ログイン',
        css: 'admin/auth/login/password/index.css',
        domain: 'admin'
    },
    a_forgot_password: {
        module: 'admin/auth/forgot-password/index',
        nameModule: 'forgotPassword',
        title: 'パッケイ ロジスティクス - パスワードリセット',
        css: 'admin/auth/forgot-password/index.css',
        domain: 'admin'
    },
    a_reset_password: {
        module: 'admin/auth/reset-password/index',
        nameModule: 'resetPassword',
        title: 'パッケイ ロジスティクス - パスワードリセット',
        css: 'admin/auth/reset-password/index.css',
        domain: 'admin',
        params: ['token', 'email']
    },
    a_register_password: {
        module: 'admin/auth/register-password/index',
        nameModule: 'registerPassword',
        title: 'パッケイ ロジスティクス - パスワード登録',
        css: 'admin/auth/register-password/index.css',
        domain: 'admin',
        params: ['token', 'staff_sei', 'staff_mei', 'mail_address']
    },
    u_login_step_two: {
        module: 'user/auth/login/password/index',
        nameModule: 'userAuthLoginPassword',
        title: 'パッケイ ロジスティクス - ログイン',
        css: 'user/auth/login/password/index.css',
        domain: 'user'
    },
    u_forgot_password: {
        module: 'user/auth/forgot-password/index',
        nameModule: 'userForgotPassword',
        title: 'パッケイ ロジスティクス - パスワード再設定',
        css: 'user/auth/forgot-password/index.css',
        params: ['token', 'email'],
        domain: 'user'
    },
    u_reset_password: {
        module: 'user/auth/reset-password/index',
        nameModule: 'userResetPassword',
        title: 'パッケイ ロジスティクス - パスワード再設定',
        css: 'user/auth/reset-password/index.css',
        params: ['token', 'email'],
        domain: 'user'
    },
    u_register_password: {
        module: 'user/auth/register-password/index',
        nameModule: 'userRegisterPassword',
        title: 'パッケイ ロジスティクス - パスワード登録',
        css: 'user/auth/register-password/index.css',
        domain: 'user',
        params: ['token', 'staff_sei', 'staff_mei', 'mail_address']
    },
    s_login_step_two: {
        module: 'staff/auth/login/password/index',
        nameModule: 'staffAuthLoginPassword',
        title: 'パッケイ ロジスティクス - ログイン',
        css: 'staff/auth/login/password/index.css',
        domain: 'staff'
    },
    s_forgot_password: {
        module: 'staff/auth/forgot-password/index',
        nameModule: 'staffForgotPassword',
        title: 'パッケイ ロジスティクス - パスワード再設定',
        css: 'staff/auth/forgot-password/index.css',
        domain: 'staff'
    },
    s_reset_password: {
        module: 'staff/auth/reset-password/index',
        nameModule: 'resetPasswordStaff',
        title: 'パッケイ ロジスティクス - パスワード再設定',
        css: 'staff/auth/reset-password/index.css',
        domain: 'staff',
        params: ['token', 'email']
    },
    s_register_password: {
        module: 'staff/auth/register-password/index',
        nameModule: 'staffRegisterPassword',
        title: 'パッケイ ロジスティクス - パスワード登録',
        css: 'staff/auth/register-password/index.css',
        domain: 'staff',
        params: ['token', 'staff_sei', 'staff_mei', 'mail_address']
    }
};

// Layout routes
export const ROUTES = {
    'auth.php': {
        module: '../layouts/index',
        requiresAuth: false
    },
    'a_frame.php': {
        module: '../layouts/admin/index',
        requiresAuth: true
    },
    'u_frame.php': {
        module: '../layouts/user/index',
        requiresAuth: true
    },
    's_frame.php': {
        module: '../layouts/staff/index',
        requiresAuth: true
    }
};

export const getAuthRoutesByDomain = domain => {
    return Object.fromEntries(
        Object.entries(AUTH_ROUTES).filter(([_, route]) => {
            // Include routes for this domain or shared routes
            return route.domain === domain || route.domain === 'shared';
        })
    );
};

export const getContentRoutesByDomain = domain => {
    return Object.fromEntries(Object.entries(CONTENT_ROUTES).filter(([_, route]) => route.module.split('/')[0] === domain));
};

export const getAuthAuthPageByDomain = (domain, page) => {
    const authRoutes = getAuthRoutesByDomain(domain);
    const route = authRoutes[page] || null;
    // Handle login_step_one dynamically based on domain
    if (page === 'login_step_one' && route && route.domain === 'shared') {
        const domainModuleMap = {
            admin: {
                module: 'admin/auth/login/email/index',
                nameModule: 'authLoginEmail',
                css: 'admin/auth/login/email/index.css'
            },
            user: {
                module: 'user/auth/login/email/index',
                nameModule: 'userAuthLoginEmail',
                css: 'user/auth/login/email/index.css'
            },
            staff: {
                module: 'staff/auth/login/email/index',
                nameModule: 'staffAuthLoginEmail',
                css: 'staff/auth/login/email/index.css'
            }
        };

        const domainConfig = domainModuleMap[domain] || domainModuleMap.admin;
        return {
            ...route,
            module: domainConfig.module,
            nameModule: domainConfig.nameModule,
            css: domainConfig.css,
            domain
        };
    }

    return route;
};

export const getContentPageByDomain = (domain, page) => {
    const contentRoutes = getContentRoutesByDomain(domain);

    return contentRoutes[page] || null;
};

export const getPage = (page, type) => {
    const domain = getDomain();
    const layoutType = type || getLayoutType();
    const isAuth = layoutType === 'auth';

    return isAuth ? getAuthAuthPageByDomain(domain, page) : getContentPageByDomain(domain, page);
};

export const getRouters = type => {
    const domain = getDomain();
    const layoutType = type || getLayoutType();
    const isAuth = layoutType === 'auth';

    return isAuth ? getAuthRoutesByDomain(domain) : getContentRoutesByDomain(domain);
};
